export const VISIBLE_ITEMS_COUNT = 7;
